/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketTypeResponse } from '../../models/ticket-type-response';

export interface TicketControllerFindAllTicketType$Params {
}

export function ticketControllerFindAllTicketType(http: HttpClient, rootUrl: string, params?: TicketControllerFindAllTicketType$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketTypeResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerFindAllTicketType.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketTypeResponse;
      }>;
    })
  );
}

ticketControllerFindAllTicketType.PATH = '/ticket/ticket-type';
